import { PASSPORT_CLIENT } from '../baseURL'
import axios from '../config'

export default {
  //验证token有效性
  verifyToken(token) {
    return axios.get(`${PASSPORT_CLIENT}/auth/verify`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },
  //检查是否在小程序中
  checkInMiniProgram() {
    return new Promise(resolve => {
      if (-1 === navigator.userAgent.toLowerCase().indexOf('micromessenger')) {
        resolve(false)
      }
      else {
        // eslint-disable-next-line
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) resolve(true)
          else resolve(false)
        })
      }
    })
  },
}